import { useState } from 'react';
import config from '../config';
import { Purchase } from '../interfaces';

const usePurchaseAdd = () => {
  const [error, setError] = useState<string | null>(null);

  const purchaseAdd = async (purchase: Purchase): Promise<Purchase | null> => {
    try {
      const response = await fetch(`${config.centralApiBaseUrl}/purchase`, {
        method: 'POST',
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(purchase),
      });

      if (!response.ok) {
        throw new Error('Adding purchase failed');
      }

      const data = await response.json();
      return data;
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An unknown error occurred');
      return null;
    }
  };

  return { purchaseAdd, error };
};

export default usePurchaseAdd;
